var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.79996C7.52649 1.79996 3.9 5.42646 3.9 9.89996C3.9 10.6874 4.18787 11.6779 4.72736 12.8125C5.26034 13.9334 6.00446 15.1242 6.83661 16.2925C8.50054 18.6286 10.462 20.7995 11.6293 22.0304C11.8368 22.2491 12.1632 22.2491 12.3707 22.0304C13.538 20.7995 15.4995 18.6286 17.1634 16.2925C17.9955 15.1242 18.7397 13.9334 19.2726 12.8125C19.8121 11.6779 20.1 10.6874 20.1 9.89996C20.1 5.42646 16.4735 1.79996 12 1.79996ZM2.1 9.89996C2.1 4.43234 6.53238 -3.66569e-05 12 -3.66569e-05C17.4676 -3.66569e-05 21.9 4.43234 21.9 9.89996C21.9 11.076 21.4857 12.35 20.8982 13.5855C20.3042 14.8347 19.4966 16.1194 18.6295 17.3368C16.895 19.7719 14.8684 22.0124 13.6767 23.269C12.7595 24.2362 11.2405 24.2362 10.3233 23.269C9.13159 22.0124 7.10497 19.772 5.37048 17.3368C4.50342 16.1194 3.69577 14.8347 3.10178 13.5855C2.5143 12.35 2.1 11.076 2.1 9.89996ZM12 6.29996C10.426 6.29996 9.15 7.57595 9.15 9.14996C9.15 10.724 10.426 12 12 12C13.574 12 14.85 10.724 14.85 9.14996C14.85 7.57595 13.574 6.29996 12 6.29996ZM7.35 9.14996C7.35 6.58184 9.43188 4.49996 12 4.49996C14.5681 4.49996 16.65 6.58184 16.65 9.14996C16.65 11.7181 14.5681 13.8 12 13.8C9.43188 13.8 7.35 11.7181 7.35 9.14996Z",
    fill: "#282828"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.1499,
    r: 3.75,
    stroke: "#282828",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAddressIcon);
export default __webpack_public_path__ + "static/media/location-address-icon.57b3076d53789c9a613f372674ea72bd.svg";
export { ForwardRef as ReactComponent };